<template>
    <v-autocomplete
        v-model="internalValue"
        :class="buttonClass"
        :search-input.sync="search"
        :items="computedCustomers"
        item-value="id"
        item-text="name"
        placeholder="Selecteaza client"
        multiple
        single-line
    ></v-autocomplete>
</template>
<script>
    export default {
        props: {
            value: {
                type: Array,
                default () {
                    return []
                }
            },
            buttonClass: {
                type: [String, Array, Object],
                default() {
                    return ''
                }
            }
        },
        data: function () {
            return {
                customers: [],
                mandatoryCustomers: [],
                search: undefined,
                internalValue: this.value
            }
        },
        watch: {
            internalValue: {
                handler (val) {
                    this.$emit('input', val)
                }
            },
            search: {
                handler(val) {
                    this.searchCustomers(val)
                }
            }
        },
        computed: {
            computedCustomers () {
                return this._.unionBy(this.customers, this.mandatoryCustomers, 'id');
            }
        },
        methods: {
            async searchCustomers (query) {
                if (this.internalValue instanceof Array && this.internalValue.length) {
                    this.mandatoryCustomers = this.customers.filter((customer) => {
                        return this.internalValue.indexOf(customer.id) >= 0
                    })
                }
                this.customers = await this.$db.Customer
                    .where('autocomplete', query)
                    .limit(25).get()
                    .then(({data}) => data)
            }
        }
    }
</script>
